const TRANSITION_DURATION_MS = 225;
const dropdownTransitionCls = "_61dpft2i";

export { TRANSITION_DURATION_MS, dropdownTransitionCls };
import "./dropdown-transition.style.linaria.module.css";
//# sourceMappingURL=dropdown-transition.style.js.map
